module.exports = __webpack_public_path__ + "media/images/application/template/logoslider/logo-bt-8a86897b0da79cb9d3596bc71b434d8b.png";